import './router-hooks'

import Vue from 'vue'
import vuetify from './plugins/vuetify'

import App from './App.vue'
import router from './router'
import store from './store'
import services from './services'
import errorHandler from './errorHandler'
import './registerServiceWorker'
import './serviceWorkerListener'
import './assets/styles/global.scss'
import utils from '@/utils'

Vue.config.errorHandler = errorHandler
Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$services = services

new Vue({
  vuetify,
  router,
  store,
  provide: { ...services },
  render: (h) => h(App)
}).$mount('#app')
